import { render, staticRenderFns } from "./campaignEvent.vue?vue&type=template&id=56d2f6f8&scoped=true&"
import script from "./campaignEvent.vue?vue&type=script&lang=js&"
export * from "./campaignEvent.vue?vue&type=script&lang=js&"
import style0 from "./campaignEvent.vue?vue&type=style&index=0&id=56d2f6f8&lang=scss&scoped=true&"
import style1 from "./campaignEvent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2f6f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
